module.exports = __webpack_public_path__ + "static/media/image6.2076fc92.jpg";